import { render, staticRenderFns } from "./ServiceSupplier.vue?vue&type=template&id=6dbb5698&scoped=true&"
import script from "./ServiceSupplier.vue?vue&type=script&lang=js&"
export * from "./ServiceSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb5698",
  null
  
)

export default component.exports